<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">

            <v-tabs-items v-model="tab" touchless class="h-100">

                <!-- S: 생성하기 메인 -->
                <v-tab-item class="fill-height">
                    <v-layout column justify-center class="h-100">
                        <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                            <div class="mb-20 mb-lg-40">
                                <div class="mb-12 mb-lg-20 pt-4">
                                    <v-badge floating dot>
                                        <h4 class="tit--sm line-height-1">계약 정보</h4>
                                    </v-badge>
                                </div>
                                <vertical-form-table v-model="form" v-bind="{ items }" class="flex-grow-1">
                                    <template slot="계약서 선택">
                                        <autocomplete-employment-form v-model="form._form" v-bind="attrs_input" :forms="forms" placeholder="계약서를 선택해주세요" />
                                    </template>
                                    <template slot="근무지명">
                                        <autocomplete-employment-place v-model="place" v-bind="attrs_input" :returnObject=true placeholder="근로지를 선택해주세요" />
                                    </template>
                                    <template slot="근로계약 기간">
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12" md="">
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-date-field v-bind="attrs_input" v-model="form.employment.date.startsAt" placeholder="YYYY-MM-DD" :disabled="form.employment.date.fixedCheck" />
                                                    </v-col>
                                                    <v-col cols="auto">
                                                        <p class="page-text page-text--sm">~</p>
                                                    </v-col>
                                                    <v-col cols="12" sm="">
                                                        <v-date-field v-bind="attrs_input" v-model="form.employment.date.endsAt" placeholder="YYYY-MM-DD" :disabled="form.employment.date.fixedCheck" />
                                                    </v-col>
                                                </v-row>    
                                            </v-col>
                                            <v-col cols="12" md="auto">
                                                <v-checkbox hide-details label="근로 기간의 정함이 없음" class="v-input--checkbox--lg" v-model="form.employment.date.fixedCheck"/>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template slot="근로계약 시간">
                                        <v-row align="center" class="row--x-small">
                                            <v-col cols="12" md="">
                                                <v-row align="center" class="row--x-small">
                                                    <v-col>
                                                        <v-time-field v-bind="attrs_input" v-model="form.employment.hour.startsAt" placeholder="HH-MM" :disabled="form.employment.hour.fixedCheck"/>
                                                    </v-col>
                                                    <v-col cols="auto">
                                                        <p class="page-text page-text--sm">~</p>
                                                    </v-col>
                                                    <v-col cols="12" sm="">
                                                        <v-time-field v-bind="attrs_input" v-model="form.employment.hour.endsAt" placeholder="HH-MM" :disabled="form.employment.hour.fixedCheck" />
                                                    </v-col>
                                                </v-row>    
                                            </v-col>
                                            <v-col cols="12" md="auto">
                                                <v-checkbox hide-details label="근로 시간의 정함이 없음" v-model="form.employment.hour.fixedCheck"  class="v-input--checkbox--lg"/>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </vertical-form-table>
                            </div>
                            <div>
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <v-badge floating dot>
                                            <h4 class="tit--sm line-height-1">선택된 계약 대상자</h4>
                                        </v-badge>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-row class="ma-n4">
                                            <v-col cols="auto" class="pa-4">
                                                <v-btn outlined color="secondary" class="min-w-140px min-w-lg-160px" @click="searchEmployment()">채용공고에서 찾기</v-btn>
                                            </v-col>
                                            <v-col cols="auto" class="pa-4">
                                                <v-btn outlined color="primary" class="min-w-140px min-w-lg-160px" @click="search()">검색으로 찾기</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-card rounded="lg" flat color="grey-f7" class="mt-12 mt-md-20">
                                    <div class="pa-20">
                                        <div class="v-cards">

                                            <!-- 계약대상자 -->
                                            <employment-contract-item list v-for= "item in applicants" :key= "item?.id" :value= "item" :recruitment="item.recruitment" @cancelApplicant="cancelApplicant"/>

                                        </div>
                                    </div>
                                </v-card>
                            </div>
                        </v-sheet>
                        <div class="v-btn-group flex-wrap">
                            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click= "shows = false"><span class="grey-6--text">취소</span></v-btn>
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click= "save"><span>근로계약 체결</span></v-btn>
                        </div>
                        <v-fade-transition>
                            <v-overlay v-show="loading" color="white">
                                <v-progress-circular size="100" width="5" color="primary" indeterminate />
                            </v-overlay>
                        </v-fade-transition>
                    </v-layout>
                </v-tab-item>
                <!-- E: 생성하기 메인 -->

                <!-- 채용공고에서 찾기 -->
                <tab-search-employment v-on="{ main }" @checkedApplicants= "getApplicants" :applicants= "applicants"/>

                <!-- 검색으로 찾기 -->
                <tab-search v-on="{ main }" @checkedApplicants= "getApplicants" :applicants= "applicants"/>

            </v-tabs-items>

        </v-layout>

        <!-- 완료 모달 -->
        <employment-contract-complete v-if= "showComplete" @showComplete= "closeComplete" :applicants="applicants"/>

    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, initEmploymentContract } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import VTimeField from "@/components/plugins/vuetify/v-time-field.vue";
import AutocompleteEmploymentForm from "@/components/dumb/autocomplete-employment-form.vue";
import EmploymentContractItem from "@/components/dashboard/company/employment/contract/form/employment-contract-item.vue";
import TabSearchEmployment from "@/components/dashboard/company/employment/contract/form/tab-search-employment.vue";
import TabSearch from "@/components/dashboard/company/employment/contract/form/tab-search.vue";
import EmploymentContractComplete from "@/components/dashboard/company/employment/contract/form/employment-contract-complete.vue";
import AutocompleteEmploymentPlace from '@/components/dumb/autocomplete-employment-place.vue';

const items = [
    {
        key: "_form",
        term: "계약서 선택",
    },
    {
        key: "employment.place",
        term: "근무지명",
        type: "select",
        placeholder: "근무지를 선택해주세요",
        returnObject: true
    },
    {
        key: "employment.date",
        term: "근로계약 기간",
        type: "dates",

    },
    {
        key: "employment.hour",
        term: "근로계약 시간",
        type: "hours",

    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        VDateField,
        VTimeField,
        AutocompleteEmploymentForm,
        EmploymentContractItem,
        TabSearchEmployment,
        TabSearch,
        EmploymentContractComplete,
        AutocompleteEmploymentPlace,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
        forms: { type: Array, default: []}
    },
    data: () => ({
        form: initEmploymentContract(),
        completeForms: [],
        showComplete: false,
        applicants: [],
        initSearch: '',
        items,
        attrs_input,

        shows: false,
        loading: false,

        tab: 0,
        place: null
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "근로자 계약 ";
            title += this.isCreate ? "생성하기" : "수정하기";
            return title;
        },
    },
    watch: {
        shows() {
            if (this.shows){ 
                this.init();
            }
            else if (this.form?._id) this.$emit("input", this.form);
        },
        "form.employment.hour.fixedCheck"(){
            this.form.employment.hour.startsAt = null;
            this.form.employment.hour.endsAt = null;
        },
        "form.employment.date.fixedCheck"(){
            this.form.employment.date.startsAt = null;
            this.form.employment.date.endsAt = null;
        },
        forms(){
            this.init();
        },
        place(){
            this.form.employment.place._place = this.place?._id,
            this.form.employment.place.title = this.place?.title,
            this.form.employment.place.postcode = this.place?.postcode,
            this.form.employment.place.address1 = this.place?.address1,
            this.form.employment.place.address2 = this.place?.address2,
            this.form.employment.place.geolocation = this.place?.geolocation
        }
        
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.isCreate){
                    this.form = initEmploymentContract();
                    this.initForm();
                    }
                else {
                    const { form } = await api.v1.company.employment.contracts.get({ _id: this.value?._id });
                    this.form = initEmploymentContract(form);
                    this.initForm();
                }
            } finally {
                this.loading = false;
            }
        },
        async save() {
            this.loading = true;
            try {
                this.showComplete = true;

                this.completeFormArr();
                let { completeForms } = this;

                await Promise.all([
                    completeForms.map(async(form) => { await api.v1.company.employment.contracts.post(form) })
                ]);

                this.init()
            } catch(e) {
                console.error(e)
            }
        },
        main() {
            this.tab = 0;
        },
        searchEmployment() {
            this.tab = 1;
        },
        search() {
            this.tab = 2;
        },
        getApplicants(values){
            for(let value of values){
                let idx = this.applicants.map(e=>e._id).indexOf(value._id);
                if(idx === -1){
                    this.applicants.push(value);
                }
            }
        },
        cancelApplicant(value){
            if(value){
                let idx = this.applicants.map(e=>e._id).indexOf(value._id);
                if(idx === -1){
                    console.error('이미 취소된 지원자입니다.')
                } else{
                    this.applicants.splice(idx,1);
                }
            }
        },
        completeFormArr(){
            let { applicants, form } = this;
            for (let applicant of applicants){
                form = {
                    ...form,
                    _person : applicant.resume._person,
                    _application : applicant._id
                }
                this.completeForms.push(form)
            }
        },
        initForm(){
            this.applicants= [];
            this.completeForms= [];
            this.place = null;
        },
        closeComplete(){
            this.showComplete = false;
            this.shows = false;
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.row--x-small{
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
</style>